import { useEffect, useMemo, useState } from "react";
import { AddUpdateRuleEngineModal, BackButton, BadgeComponent, Breadcrumbs, ButtonComponent, ConfirmationModalComponent, DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent } from "../../components";
import { PlusSvg, VerticalDotsSvg } from "../../assets/svgs";
import { useDispatch, useSelector } from "react-redux";
import { providerInstitutionConstant, statusOptionsBoolean } from "../../constants/user-constants";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { getAllRules, getCountryList, postAddUpdateRuleEngine } from "../../redux/slices/rule-engine-slice";
import { ruleEngineConstant } from "../../constants/app-constants";
import { useLocation } from "react-router";
import { Menus } from "../../constants/menus-constant";
import ReactTable from "react-table";
import { getInstitutionsList } from "../../redux/slices/institutions-list-slice";

const RuleEngine = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { institutionsWithID } = useSelector((state) => state.institutionsListReducer);
    const { loading, rulesData, pagination } = useSelector((state) => state.ruleEngineReducer);

    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];
    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };
    const initialOrderBy = {
        sortColumn: "ruleCreationDate",
        isAsce: false,
    };
    const initialSearch = {
        institutionId: '',
        bin: '',
        status: undefined,
        creationDate: '',
    };

    const initialForm = {
        institution: isProvider ? '' : user?.institution?.id,
        configurations: [
            {
                scheme: [],
                bins: [],
                numberOfSuccessfullTransactionLow: '',
                numberOfSuccessfullTransactionMedium: '',
                numberOfSuccessfullTransactionHigh: '',
                numberOfSuccessfullTransactionLowScore: 0,
                numberOfSuccessfullTransactionMediumScore: 0,
                numberOfSuccessfullTransactionHighScore: 0,
                numberOfDaysLow: '',
                purchaseAmountLow: '',
                purchaseAmountMedium: '',
                purchaseAmountHigh: '',
                frictionlessScoreThreshold: '',
                purchaseAmountLowScore: 0,
                purchaseAmountMediumScore: 0,
                purchaseAmountHighScore: 0,
                deviceFingerPrintScore: 0,
                currencies: [],
                currencyCodeScore: 0,
                numberOfSuccessfullTransactionWeitage: '',
                purchaseAmountWeitage: '',
                deviceFingerPrintWeitage: '',
                currencyCodeWeitage: '',
                effectiveDateTime: '',
                isConfigured: ruleEngineConstant?.isNotConfigured,
            },
        ],
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        orderBy: initialOrderBy,
        search: initialSearch,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isConfirmModal: null,
        isUpdate: false,
        isView: false,
        isFiltersOpen: false,
    };

    const [states, setStates] = useState(initialStates);

    const [form, setForm] = useState(initialForm);

    const defaultParams = { pagination: states.pagination, orderBy: states.orderBy, search: states.search };

    const getAllRulesData = (updatedParams) => {
        if (user && updatedParams) {
            dispatch(getAllRules({ user, ...updatedParams }));
            dispatch(getInstitutionsList(user));
        }
    };

    // const handleReload = () => {
    //     getAllRulesData(defaultParams);
    // };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getAllRulesData(params);
    };

    // const handleChangeFilters = (e) => {
    //     const { name, value, type, checked } = e.target
    //     setStates((old) => ({
    //         ...old,
    //         search: ({
    //             ...old.search,
    //             [name]: ['checkbox', 'radio'].includes(type) ? checked : value
    //         })
    //     }));
    // };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    // const handleToggleFilters = () => {
    //     setStates((old) => ({ ...old, search: initialSearch, isFiltersOpen: !states.isFiltersOpen }));
    // };

    const handleModalOpen = (e) => {
        if (['view', 'edit', 'activate', 'deactivate'].includes(e)) {
            const selected = states?.selected;

            const getRuleFieldValue = (binRange, ruleName, fieldName) => {
                const rule = binRange?.rules?.find(r => r.ruleName === ruleName);
                const field = rule?.ruleFields?.find(f => f.fieldName === fieldName);
                return field?.ruleFieldValues?.[0];
            };

            const getRuleFieldValues = (binRange, ruleName, fieldName) => {
                const rule = binRange?.rules?.find(r => r.ruleName === ruleName);
                const field = rule?.ruleFields?.find(f => f.fieldName === fieldName);
                return field?.ruleFieldValues || [];
            };

            setForm({
                institution: Number(selected?.id),
                configurations: selected?.institutionBinRanges?.map((binRange, index) => {
                    // Get field values for common rule lookups
                    const historyTxnValues = getRuleFieldValues(binRange, "History Validation", "numberOfSuccessfullTransaction");
                    const daysValue = getRuleFieldValue(binRange, "History Validation", "transactionDateTime");
                    const amountValues = getRuleFieldValues(binRange, "Amount Activation", "purchaseAmount");
                    const deviceFingerPrintValue = getRuleFieldValue(binRange, "Device Fingerprint Validation", "deviceFingerPrintCount");
                    const currencyValue = getRuleFieldValues(binRange, "Currency Code Validation", "purchaseCurrency");
                    const frictionlessScoreThreshold = binRange?.ruleScoreMatrix?.frictionlessScoreThreshold;

                    return {
                        id: index + 1,
                        scheme: [],
                        bins: [{
                            label: binRange?.bin,
                            value: binRange?.id,
                            scheme: {
                                label: binRange?.schemeId?.name,
                                value: binRange?.schemeId?.id,
                                logo: binRange?.schemeId?.logoDataUri
                            }
                        }],
                        // Number of Successful Transactions - extract from array values
                        numberOfSuccessfullTransactionLow: historyTxnValues?.[0]?.fieldValue || "",
                        numberOfSuccessfullTransactionMedium: historyTxnValues?.[1]?.fieldValue || "",
                        numberOfSuccessfullTransactionHigh: historyTxnValues?.[2]?.fieldValue || "",
                        numberOfSuccessfullTransactionLowScore: historyTxnValues?.[0]?.score || 0,
                        numberOfSuccessfullTransactionMediumScore: historyTxnValues?.[1]?.score || 0,
                        numberOfSuccessfullTransactionHighScore: historyTxnValues?.[2]?.score || 0,
                        // Number of Days
                        numberOfDaysLow: daysValue?.fieldValue || "",
                        // Purchase Amount - extract from array values
                        purchaseAmountLow: amountValues?.[0]?.fieldValue || "",
                        purchaseAmountMedium: amountValues?.[1]?.fieldValue || "",
                        purchaseAmountHigh: amountValues?.[2]?.fieldValue || "",
                        purchaseAmountLowScore: amountValues?.[0]?.score || 0,
                        purchaseAmountMediumScore: amountValues?.[1]?.score || 0,
                        purchaseAmountHighScore: amountValues?.[2]?.score || 0,
                        // Direct values
                        deviceFingerPrintScore: deviceFingerPrintValue?.score || 0,
                        currencies: currencyValue?.map(c => c.fieldValue.trim()) || [],
                        currencyCodeScore: currencyValue?.[0]?.score || 0,
                        frictionlessScoreThreshold: frictionlessScoreThreshold || "",
                        effectiveDateTime: binRange?.ruleEffectedDate || "",
                        // rule weitage - values
                        numberOfSuccessfullTransactionWeitage: historyTxnValues?.[0]?.weitage || "",
                        purchaseAmountWeitage: amountValues?.[0]?.weitage || "",
                        deviceFingerPrintWeitage: deviceFingerPrintValue?.weitage || "",
                        currencyCodeWeitage: currencyValue?.[0]?.weitage || 0,
                        // Summary values for table display - create arrays in expected format
                        numberOfDays: daysValue ? [{
                            risk: 'LOW', 
                            value: daysValue.fieldValue,
                            operator: daysValue.operator
                        }] : [],
                        numberOfSuccessfullTransaction: historyTxnValues?.map((value, idx) => ({
                            risk: ['LOW', 'MEDIUM', 'HIGH'][idx],
                            value: value.fieldValue,
                            score: value.score,
                            operator: value.operator
                        })) || [],
                        purchaseAmount: amountValues?.map((value, idx) => ({
                            risk: ['LOW', 'MEDIUM', 'HIGH'][idx],
                            value: value.fieldValue,
                            score: value.score,
                            operator: value.operator
                        })) || [],
                        rulesWeitage:{
                            numberOfSuccessfullTransactionWeitage: historyTxnValues?.[0]?.weitage || "",
                            purchaseAmountWeitage: amountValues?.[0]?.weitage || "",
                            deviceFingerPrintWeitage: deviceFingerPrintValue?.weitage || "",
                            currencyCodeWeitage: currencyValue?.[0]?.weitage || 0,
                        },
                        ruleScoreMatrix: {
                            frictionlessScoreThreshold: frictionlessScoreThreshold || "",
                        },
                        rulesOperator: {
                            numberOfSuccessfullTransaction: historyTxnValues?.[0]?.operator?.signature || "Greater-equal",
                            numberOfDays: daysValue?.operator?.signature || "Greater-equal",
                            purchaseAmount: amountValues?.[0]?.operator?.signature || "Less-equal",
                        },
                        isConfigured: 2,
                    };
                })
            });

            if (e === 'view') {
                setStates((old) => ({ ...old, isView: true, isModalOpen: true }));
            } else if (e === 'edit') {
                setStates((old) => ({ ...old, isUpdate: true, isModalOpen: true }));
            } else if (['activate', 'deactivate'].includes(e)) {
                setStates((old) => ({ ...old, isUpdate: true, isConfirmModal: e, isModalOpen: false }));
            }
        } else {
            setStates((old) => ({ ...old, isModalOpen: true }));
            setForm(initialForm);
        }
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, isConfirmModal: null, selected: null, isUpdate: false, isView: false }));
    };

    const handleFormSubmit = (payload) => {
        if (user && form) {
            dispatch(postAddUpdateRuleEngine({ user, body: payload, update: states.isUpdate })).then((action) => {
                if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                    handleModalClose();
                    getAllRulesData(defaultParams);
                }
            });
        }
    };

    const handleActivate = (state) => {
        if (user) {
            const updatedBody = {
                institutionId: form?.institution,
                institutionRuleStatus: state,
                changeStatus: true,
                institutionBinRanges: form?.configurations?.map((config) =>
                    config?.bins?.map(bin => ({
                        binRangeId: bin?.value,
                        bin: bin?.label,
                        rulesConfiguration: {
                                numberOfDays: (config?.numberOfDays) ? config.numberOfDays : [
                                    { risk: 'LOW', value: config?.numberOfDaysLow },
                                ],
                                numberOfSuccessfullTransaction: Array.isArray(config?.numberOfSuccessfullTransaction) ? config.numberOfSuccessfullTransaction : [
                                    { risk: 'LOW', value: config?.numberOfSuccessfullTransactionLow, score: config?.numberOfSuccessfullTransactionLowScore },
                                    { risk: 'MEDIUM', value: config?.numberOfSuccessfullTransactionMedium, score: config?.numberOfSuccessfullTransactionMediumScore },
                                    { risk: 'HIGH', value: config?.numberOfSuccessfullTransactionHigh, score: config?.numberOfSuccessfullTransactionHighScore }
                                ],
                                purchaseAmount: Array.isArray(config?.purchaseAmount) ? config.purchaseAmount : [
                                    { risk: 'LOW', value: config?.purchaseAmountLow, score: config?.purchaseAmountLowScore },
                                    { risk: 'MEDIUM', value: config?.purchaseAmountMedium, score: config?.purchaseAmountMediumScore },
                                    { risk: 'HIGH', value: config?.purchaseAmountHigh, score: config?.purchaseAmountHighScore }
                                ],
                                deviceFingerPrintScore: config?.deviceFingerPrintScore,
                                currencies: config?.currencies,
                                currencyCodeScore: config?.currencyCodeScore,
                                effectiveDateTime: config?.effectiveDateTime
                            },
                            rulesWeitage: {
                                numberOfSuccessfullTransactionWeitage: config?.numberOfSuccessfullTransactionWeitage || "",
                                purchaseAmountWeitage: config?.purchaseAmountWeitage || "",
                                deviceFingerPrintWeitage: config?.deviceFingerPrintWeitage || "",
                                currencyCodeWeitage: config?.currencyCodeWeitage || "",
                            },
                            ruleScoreMatrix: {
                                frictionlessScoreThreshold: config?.frictionlessScoreThreshold || "",
                            },
                            rulesOperator: config?.rulesOperator,
                    }))
                ).flat()
            };

            dispatch(postAddUpdateRuleEngine({ user, body: updatedBody, update: states.isUpdate })).then((action) => {
                if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                    handleModalClose();
                    getAllRulesData(defaultParams);
                }
            });
        }
    };

    const handleFiltersSubmit = (e, customSearch = null) => {
        if (e) e.preventDefault();
        const searchToUse = customSearch || states.search;
        const params = {
            ...defaultParams,
            search: searchToUse,
            pagination: initialPagination,
        };
        getAllRulesData(params);
    };

    const handleTableFilterChange = (key, value, submit = false) => {
        setStates(old => {
            const updatedSearch = { ...old.search, [key]: value || '' };
            if (submit) {
                setTimeout(() => {
                    handleFiltersSubmit(null, updatedSearch);
                }, 0);
            }
            return { ...old, search: updatedSearch };
        });
    };



    const actions = (status) => {
        const actionsList = [
            { label: 'View', action: () => handleModalOpen('view') },
        ];

        if (status) {
            // actionsList.push({ label: 'Edit', action: () => handleModalOpen('edit') });
            actionsList.push({ label: 'Deactivate', action: () => handleModalOpen('deactivate') });
        } else if (!status) {
            actionsList.push({ label: 'Activate', action: () => handleModalOpen('activate') });
        }

        return actionsList;
    };

    useEffect(() => {
        getAllRulesData(defaultParams);
        dispatch(getCountryList(user));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (rulesData && Array.isArray(rulesData)) {
            setStates((old) => ({ ...old, data: rulesData, pagination: pagination }));
        }
    }, [rulesData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // const searchFields = [
    //     {
    //         label: 'Bin',
    //         type: 'text',
    //         placeholder: 'Search by bin',
    //         name: 'bin',
    //         value: states.search.bin,
    //     },
    //     {
    //         label: 'Institution',
    //         type: 'select',
    //         options: institutionsWithID,
    //         name: 'institutionId',
    //         value: states.search.institutionId,
    //     },
    //     {
    //         label: 'Status',
    //         type: 'select',
    //         options: statusOptionsBoolean,
    //         name: 'status',
    //         value: states.search.status,
    //     },
    //     {
    //         label: 'Created At',
    //         type: 'date',
    //         placeholder: 'Search by date',
    //         name: 'creationDate',
    //         value: states.search.creationDate,
    //     },
    //     {
    //         type: 'action',
    //         actions: [
    //             { label: 'Cancel', icon: CrossSvg, type: 'button', outline: true, action: handleToggleFilters },
    //             { label: 'Search', icon: SearchSvg, type: 'submit', action: () => { } }
    //         ],
    //     },
    // ];

    // TABLE COLUMNS SETUP AS PER DATA
    // const columns = [
    //     { field: 'descr', headerName: 'Institution', width: 120 },
    //     {
    //         field: 'institutionBinRanges',
    //         headerName: 'Configured Bins',
    //         sortable: false,
    //         width: 170,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.institutionBinRanges && row?.institutionBinRanges?.length > 0 && (
    //                             <>
    //                                 {row?.institutionBinRanges.slice(0, 3).map(bin => bin?.bin).join(', ')}
    //                                 {row?.institutionBinRanges.length > 3 &&
    //                                     `, +${row?.institutionBinRanges.length - 3}`
    //                                 }
    //                             </>
    //                         )
    //                     }
    //                 </>
    //             )
    //         },
    //     },
    //     {
    //         field: 'institutionRuleStatus',
    //         headerName: 'Status',
    //         width: 100,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.institutionRuleStatus !== null && row?.institutionRuleStatus !== undefined && (
    //                             <BadgeComponent
    //                                 label={row?.institutionRuleStatus ? 'Active' : 'In-Active'}
    //                                 type={row?.institutionRuleStatus ? 'success' : 'warning'}
    //                             />
    //                         )
    //                     }
    //                 </>
    //             )
    //         },
    //         sortBy: (row) => row?.institutionRuleStatus,
    //     },
    //     { field: 'ruleCreationDate', headerName: 'Created At', width: 170, align: 'center' },
    //     {
    //         field: 'action',
    //         headerName: 'Action',
    //         sortable: false,
    //         width: 100,
    //         align: 'right',
    //         sticky: 'right',
    //         valueGetter: (row) => {
    //             return (
    //                 <div className="action-dropdown" style={{ position: 'relative', float: 'right' }}>
    //                     <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row)} />
    //                     <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row} close={handleCloseDropdown} actions={actions(row?.institutionRuleStatus)} />
    //                 </div>
    //             )
    //         },
    //     },
    // ];

    const columns = useMemo(() => [
        {
            accessor: 'ruleCreationDate',
            Header: 'Created At',
            minWidth: 200,
            style: {
                textAlign: 'center'
            },
            Filter: ({ filter, onChange }) => (
                <input
                    type="date"
                    name="creationDate"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('creationDate', value, true);
                    }}
                    // onKeyDown={(e) => {
                    //     if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                    //         const value = e.target.value === '' ? undefined : e.target.value;
                    //         onChange(value);
                    //         handleTableFilterChange('creationDate', value, true);
                    //     }
                    // }}
                    placeholder="Search by date"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
            filterable: isProvider ? true : false,
        },
        {
            accessor: 'descr',
            Header: 'Institution',
            minWidth: 200,
            style: {
                textAlign: 'center'
            },
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <select
                    name="institutionId"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('institutionId', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        institutionsWithID.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        ))
                    }
                </select>
            ),
            filterable: isProvider ? true : false,
        },
        {
            accessor: 'institutionBinRanges',
            Header: 'Configured Bins',
            minWidth: 200,
            sortable: false,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.institutionBinRanges && row?.original?.institutionBinRanges?.length > 0 && (
                                <>
                                    {row?.original?.institutionBinRanges.slice(0, 3).map(bin => bin?.bin).join(', ')}
                                    {row?.original?.institutionBinRanges.length > 3 &&
                                        `, +${row?.original?.institutionBinRanges.length - 3}`
                                    }
                                </>
                            )
                        }
                    </>
                )
            },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="bin"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('bin', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('bin', value, true);
                        }
                    }}
                    placeholder="Search by Bin"
                    style={{ width: '100%' }}
                />
            ),
            // filterable: false,
        },
        {
            accessor: 'institutionRuleStatus',
            Header: 'Status',
            minWidth: 160,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.institutionRuleStatus !== null && row?.original?.institutionRuleStatus !== undefined && (
                                <BadgeComponent
                                    label={row?.original?.institutionRuleStatus ? 'Active' : 'In-Active'}
                                    type={row?.original?.institutionRuleStatus ? 'success' : 'warning'}
                                />
                            )
                        }
                    </>
                )
            },
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <select
                    name="status"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('status', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        statusOptionsBoolean.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        ))
                    }
                </select>
            ),
           filterable: isProvider ? true : false,
        },
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            // style: {
            //     height: 45, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
            // },
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row?.original)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row?.original)} />
                        <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row?.original} close={handleCloseDropdown} actions={actions(row?.original?.institutionRuleStatus)} />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [states.isDropdownOpen, states.selected, institutionsWithID]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>Rule Engine</h1>
                    {/* <IconButtonComponent icon={ReloadSvg} outline size="small" disabled={loading} onClick={handleReload} className={loading && 'box-spin'} /> */}
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/home" },
                            { label: PageLabel }
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>

                <div className="right">
                    <ButtonComponent icon={PlusSvg} label="Add rule" size="small" disabled={loading} onClick={handleModalOpen} />
                    {/* <IconButtonComponent icon={FilterSvg} outline onClick={handleToggleFilters} /> */}
                </div>
            </AuthPageHead>

            {/* FILTER */}
            {/* {
                searchFields && searchFields.length > 0 &&
                <FiltersComponent open={states.isFiltersOpen} searchFields={searchFields} handleChange={handleChangeFilters} handleSubmit={handleFiltersSubmit} />
            } */}

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* EMPTY STATE */}
            {/*
                !loading && states.data && states.data.length === 0 &&
                <EmptyTableComponent text='No data found!' />
            */}

            {/* PAGE CONTENT */}
            {
                // !loading && states.data && states.data.length > 0 &&
                <>
                   <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        {/* <TableComponent rows={states.data} columns={columns} icon={BadgeSvg} />
                    <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} /> */}
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={true}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            // defaultFilterMethod={(filter, row, column) => {
                            //     return true;
                            // }}
                            // onFilteredChange={(filtered, column, value) => {
                            //     const searchCriteria = transformToObject(filtered);
                            //     setComponentState((prevState) => ({
                            //         ...prevState,
                            //         searchCriteria,
                            //         tableLoading: true,
                            //     }));

                            //     handleOnSearch(searchCriteria); // Trigger handle search
                            // }}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {
                states.isModalOpen &&
                <AddUpdateRuleEngineModal data={form} label={`${states.isUpdate ? 'Update' : states.isView ? 'View' : 'Add'} Rules`} viewOnly={states.isView} update={states.isUpdate} close={handleModalClose} handleFormSubmit={handleFormSubmit} emptyConfigurations={initialForm?.configurations[0]} slide />
            }
            {
                states.isConfirmModal && states.isConfirmModal === 'activate' &&
                <ConfirmationModalComponent
                    type='success'
                    label='Activate rule engine'
                    text={`Are you sure you want to activate rule engine (${states?.selected?.descr})?`}
                    close={handleModalClose}
                    actions={[
                        { label: 'No', type: 'button', outline: true, action: handleModalClose },
                        { label: 'Yes', type: 'button', action: () => handleActivate(true) }
                    ]}
                />
            }
            {
                states.isConfirmModal && states.isConfirmModal === 'deactivate' &&
                <ConfirmationModalComponent
                    type='warning'
                    label='Deactivate rule engine'
                    text={`Are you sure you want to deactivate rule engine (${states?.selected?.descr})?`}
                    close={handleModalClose}
                    actions={[
                        { label: 'No', type: 'button', outline: true, action: handleModalClose },
                        { label: 'Yes', type: 'button', action: () => handleActivate(false) }
                    ]}
                />
            }
        </AuthPageContainer>
    );
};

export default RuleEngine;